import Helper from './Helper';

class Animations {
  constructor(config = {}) {
    const {targetQuery } = config;
    this.targetQuery = targetQuery ? targetQuery : '.ns-teaserbox';

    this.targets = document.querySelectorAll(this.targetQuery);

    this.targets.forEach(e => {
      if (!Helper.jizzInViewport(e)) {
        e.classList.add('animate');
      } else {
        e.classList.add('animate');
        e.classList.add('animated');
      }
      Helper.loadImagesInDomElement(e);
    });


    this.handleScroll(this.targets);

    window.addEventListener("scroll", e => {
      this.handleScroll(this.targets);
    });
  }

  handleScroll(elements) {
    elements.forEach(e => {
      if (Helper.jizzInViewport(e)) {
        e.classList.add('animated');
      }
    });
  }
}
export default Animations;